import React from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {
    Link
  } from 'react-router-dom';
import { Grid } from 'antd-mobile';
import AppHeader from './AppHeader';
import mmph from 'myanmar-phonenumber';
import { sealCheckout } from '../../utils/secureCheckout';

class PasswordRestPage extends React.Component {
    constructor(props) {
        super(props)

        //passwordreset
        this.state = { step: "passwordreset", message : "", username: '', form : { phone: '', bank_transaction_id: '', password: '', re_new_password: '' }, seconds: 60, isCounting: false};
        this.validatePhone        = this.validatePhone.bind(this);
        this.nextPhone            = this.nextPhone.bind(this);
        this.backToPhone          = this.backToPhone.bind(this);
        this.verifyTransactionApi = this.verifyTransactionApi.bind(this);
        this.changePasswordApi    = this.changePasswordApi.bind(this);
        this.showHide             = this.showHide.bind(this);
    }

    startCountdown = () => {
        this.setState({ isCounting: true });
        const intervalId = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.seconds === 0) {
                    clearInterval(intervalId);
                    this.setState({ isCounting: false });
                    return { seconds: 60 }
                }
                return { seconds: prevState.seconds - 1 }
            });
        }, 1000);
    }
    
    handleOtpRequest = () => {
        // Send the phone number to the server to request a new OTP
        // ...
        this.startCountdown();
    }



    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          } else {
            if(menu[menu.length - 1] !== url ){
              menu.push(url)
              localStorage.setItem("route", JSON.stringify(menu) );
            }
          }
        }
       // console.log(localStorage.getItem('route'));
    }

    showHide() {

        if(this.state.show_hide == false) {
            this.setState({ show_hide: true });
        } else {
            this.setState({ show_hide: false });
        }

    }

    checklogin() {
      if(localStorage.getItem(window.BPdata.time)) {
          if(localStorage.getItem(window.BPdata.time) !== "0" ) {
              return true;
          }
      }
      return false;
    }

    componentDidMount() {
        // console.log(mmph.normalizeInput('+၉၅၉၇၈၄၁၂၃၄၅၆')); // returns 09784123456
        // console.log(mmph.normalizeInput('+959784123456')); // returns 09784123456
        // console.log(mmph.getTelecomName('09978412345')); // returns Ooredoo
        // console.log(mmph.getPhoneNetworkType('09978412345')); // returns GSM
        // console.log(mmph.isValidMMPhoneNumber('09978412345')); // returns true if it meets Myanmar Phone
        if(localStorage.getItem(window.BPdata.time)) {
            if(localStorage.getItem(window.BPdata.time) !== "0" ) {
              this.setState({ step: "profile" });
            }

          }
        // if(localStorage.getItem('username')) {
        //         this.setState({
        //             form: {
        //                 username : localStorage.getItem('username')
        //             }
        //         });
        // }

        this.hisUrl('/more/password-reset');
    }

    // componentWillUpdate() {
    //     localStorage.setItem('route', '/more/sign-up');
    //     console.log(localStorage.getItem('route'))
    // }

    inputChangeHandler(e) {
        let form = {...this.state.form};
        form[e.target.name] = e.target.value;
        this.setState({
            form
        });
    }

    // Step 1 -> Step 2: validate phone, then show the transaction id box
    nextPhone() {
        let form = this.state.form
        if(form.phone.length > 6 && mmph.isValidMMPhoneNumber(form.phone)) {
            this.setState({ message : "", step : "transaction" });
        } else {
            this.setState({ message : window.lang.messages.invalid_phone });
        }
    }

    backToPhone() {
        this.setState({ message : "", step : "passwordreset" });
    }

    validatePhone() {
        let form = this.state.form
        if(form.phone.length > 6 && mmph.isValidMMPhoneNumber(form.phone)) {
            if(!form.bank_transaction_id || form.bank_transaction_id.trim().length < 1) {
                this.setState({ message : window.lang.messages.reset_transaction_hint });
                return;
            }
            this.setState({ message : "" });
            this.verifyTransactionApi({ phone : form.phone, bank_transaction_id : form.bank_transaction_id });
        } else {
            this.setState({ message : window.lang.messages.invalid_phone });
        }
    }

    // Verify identity by matching the last deposit transaction id.
    // On match the new-password + confirm fields are shown.
    verifyTransactionApi(formdata) {
        var self = this;
        let dataurl = window.BPdata.apiUrlCMSV2+'/player/reset-verify-transaction';
        axios({
            method: 'post',
            url: dataurl,
            data: sealCheckout(formdata),
            headers: { 'content-type': 'application/json;charset=UTF-8',
                "X-Trident-Token" : window.BPdata.token,
                "BP-Agent"        : window.BPdata.rand_compound
            },
        })
        .then(function (response) {
            if(response.data.data.status == 200) {
                self.setState({  message : "", step : "password" });
            } else {
                // 403 -> mismatch (with remaining attempts) or contact-support message
                self.setState({  message : response.data.data.message });
            }
        })
        .catch(function (error) {
            // console.log(error);
        });
    }

    changePasswordApi() {
        if(this.state.form.password !== this.state.form.re_new_password) {
            this.setState({  message : "စကားဝှက် နှစ်ခု ကိုက်ညီမှု မရှိပါ" });
            return;
        }
        if(this.state.form.password.length >= 6) {
            let formdata = this.state.form ;
            var self = this;
            let dataurl = window.BPdata.apiUrlCMSV2+'/player/reset-pwd-transaction';
            axios({
                method: 'post',
                url: dataurl,
                data: sealCheckout(formdata),
                headers: { 'Content-Type': 'application/json;charset=UTF-8',
                    "X-Trident-Token" : window.BPdata.token,
                    "BP-Agent"         : window.BPdata.rand_compound
                },
            })
            .then(function (response) {

                if(response.data.data.status == 403) {
                    self.setState({  message : response.data.data.message });
                } else if(response.data.data.status == 200) {
                    self.setState({  message : response.data.data.message , step : "profile" });
                    // localStorage.setItem(window.BPdata.time, self.state.form.phone );
                    localStorage.setItem(window.BPdata.time, response.data.data.token );
                    localStorage.setItem('username', self.state.form.username );
                }  else {
                    self.setState({  message : "တစ်ခုခုတော့မှားနေပြီ" });
                }

                //console.log(response.data.success);
            })
            .catch(function (error) {
                // console.log(error);
            });
        } else {
            this.setState({  message : "စကားဝှက်မှာအနည်းဆုံးအက္ခရာ ၆ လုံးရှိရမည်" });
        }

    }

    viewHandler() {

        switch(this.state.step) {
            // case "line-up":   return "";
            case "passwordreset": return this.passwordResetBlock();
            case "transaction": return this.transactionBlock();
            case "password": return this.passwordBlock();
            case "profile": return this.profileBlock();
            default:      return "";
          }
    }


    // Step 1: phone only
    passwordResetBlock() {
        return <div className="form-box">

                    <div className="row">
                        <div className="grid-90 grid-s-90">
                            <p style={{ fontSize: '0.9rem', opacity: 0.85, marginTop: '4px' }}>{window.lang.auth.reset_subtitle}</p>
                            <small style={{ opacity: 0.7, fontSize: '0.72rem' }}>{window.lang.auth.step_label} 1 / 3</small>
                            <br />
                        </div>
                    </div>

                    <div className="row page-contest">
                        <div className="grid-90 grid-s-90 left">
                            <div className="form-group text-left">
                                <label>{window.lang.form.phone}</label>
                            </div>
                        </div>
                        <div className="grid-90 grid-s-90 left text-right">
                            <div className="form-group">
                            <input type="text" className="form-control text-center" placeholder="09**********" name="phone" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.phone} />
                            <small className="text-left" style={{ display: 'block', opacity: 0.7, fontSize: '0.72rem', lineHeight: '1.35', marginTop: '4px' }}>{window.lang.auth.reset_phone_hint}</small><br />
                            </div>
                            <Link to="/more/login" className="color-theme-gold">{window.lang.form.login}</Link> | &nbsp;&nbsp;
                            <input type="submit" className="btn btn-yellow   pointer grid-40" value={window.lang.form.to_arrow} onClick={this.nextPhone} /><br />
                            <br />
                            <small style={{ opacity: 0.7, fontSize: '0.72rem' }}>{window.lang.auth.secure_note}</small>
                        </div>

                    </div>
        </div>
    }

    // Step 2: bank transaction id
    transactionBlock() {
        return <div className="form-box">

                    <div className="row">
                        <div className="grid-90 grid-s-90">
                            <small style={{ opacity: 0.7, fontSize: '0.72rem' }}>{window.lang.auth.step_label} 2 / 3</small>
                            <br />
                        </div>
                    </div>

                    <div className="row page-contest">
                        <div className="grid-90 grid-s-90 left">
                            <div className="form-group text-left">
                                <label>{window.lang.messages.reset_transaction_hint}</label>
                            </div>
                        </div>
                        <div className="grid-90 grid-s-90 left text-right">
                            <div className="form-group">
                            <input type="text" className="form-control text-center" placeholder={window.lang.messages.reset_transaction_placeholder} name="bank_transaction_id" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.bank_transaction_id} /><br />
                            </div>
                            <a onClick={this.backToPhone} className="color-theme-gold pointer">{window.lang.form.from_arrow}</a> | &nbsp;&nbsp;
                            <input type="submit" className="btn btn-yellow   pointer grid-40" value={window.lang.form.submit} onClick={this.validatePhone} /><br />
                        </div>

                    </div>
        </div>
    }

    passwordBlock() {
        return <div>
                    <div className="row">
                        <div className="grid-90 grid-s-90">
                            <small style={{ opacity: 0.7, fontSize: '0.72rem' }}>{window.lang.auth.step_label} 3 / 3</small>
                            <small style={{ display: 'block', opacity: 0.7, fontSize: '0.72rem', lineHeight: '1.35', marginTop: '4px' }}>{window.lang.auth.password_rules}</small>
                            <br />
                        </div>
                    </div>
                    <div className="row page-contest">
                        <div className="grid-90 grid-s-90 left">
                            <div className="form-group text-left">
                                <label>သင့်ရဲ့ လျှို့၀ှက်နံပါတ် အသစ်ကို ရိုက်ထည့်ပါ။</label>
                            </div>
                        </div>
                        <div className="grid-90 grid-s-90 left">
                            <div className="form-group text-center" style={{ position: 'relative' }}>
                            <input
                                type={this.state.show_hide ? 'text' : 'password'}
                                className="form-control text-center"  name="password" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.password}
                            />
                            <span className='changePwd'
                                onClick={this.showHide}
                                style={{
                                position: 'absolute',
                                right: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: 'black'
                                }}
                            >
                                {this.state.show_hide ? <FaEye className='iconColor' style={{color:'black'}} /> : <FaEyeSlash style={{color:''}} />}
                            </span>
                            {/* <input type="password" className="form-control text-center"  name="password" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.password} /><br /> */}
                            </div>
                            <div className="form-group text-left mt-20">
                                <label>{window.lang.form.re_new_password}</label>
                            </div>
                            <div className="form-group text-center" style={{ position: 'relative' }}>
                            <input
                                type={this.state.show_hide ? 'text' : 'password'}
                                className="form-control text-center"  name="re_new_password" onChange={(e) => this.inputChangeHandler.call(this, e)} value={this.state.form.re_new_password}
                            />
                            <span className='changePwd'
                                onClick={this.showHide}
                                style={{
                                position: 'absolute',
                                right: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: 'black'
                                }}
                            >
                                {this.state.show_hide ? <FaEye className='iconColor' style={{color:'black'}} /> : <FaEyeSlash style={{color:''}} />}
                            </span>
                            </div>
                            <p className="color-red" style={{ fontSize: '0.8rem', lineHeight: 1.9, textAlign: 'left', margin: '22px 0' }}>
                                ငွေလိမ်လည်မှုမှကာကွယ်ရန် သင်၏ စကားဝှက် ကိုမည်သူနှင့်မျှမပြောပြပါနှင့်။<br />
                                ဝန်ဆောင််မှုဝန်ထမ်းလည်း သင်၏ စကားဝှက် ကိုမေးခွင့်လုံးဝမရှိပါ။ မေးခဲ့ပါက အတုအယောင်များသာဖြစ်ပါသည်။
                            </p>
                            <input type="submit" className="btn btn-yellow   pointer grid-50" value={window.lang.form.submit} onClick={this.changePasswordApi} /><br />
                        </div>

                    </div>
        </div>
    }

    profileBlock() {
        return <div>
            <div className="row">
                <h2>Hi {((this.state.form.username)? this.state.form.username : "Customer")}</h2>
                <p>Welcome to ThaHtayLay App</p>
                <br />
                <img src="/img/logo.png" className="medium-logo" />
                <br />
            </div>
        </div>
    }

    render() {
        return (
            <div className="page">
                <div className="page-content text-center">
                <AppHeader titleType="2" title={window.lang.form.password_reset} isLoading="false" />

                    <div className="main-content">
                        <br />
                        <br />
                         { (this.state.step != "profile") ?
                        <h1 className="color-theme-gold">{window.lang.form.password_reset}</h1> : "" }
                        <br />
                        <span>{this.state.message}</span>

                        { this.viewHandler() }
                    </div>
                </div>
                <footer  className="App-footer">

                  <div className="App-footer-inner">
                    {/* {window.BPdata.footerMenu} */}
                    <Grid data={window.lang.footer}
                        columnNum={5}
                        renderItem={dataItem => (

                          <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{width: '100%'}}>
                                { (window.BPdata.footerMenu === dataItem.check )  ? (dataItem.text == "My Profile") ?  <span className="color-white"><img src={dataItem.icon}  height="25px"/><br />{(this.checklogin()) ? dataItem.text : "Login / Register" }</span> : <span className="text-white"><img src={dataItem.icon_off}  height="25px"/><br /><span >{dataItem.text}</span> </span> : <span className="text-white"><img src={dataItem.icon}  height="25px"/><br />{dataItem.text} </span> }

                          </Link>
                        )}
                      />

                  </div>
                </footer>
            </div>
        );
    }
}

export default PasswordRestPage;
